module.exports = __webpack_public_path__ + "img/special.57798054.png";